import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { useAuth } from '../../utils/useAuth';
import ErrorBoundary from './ErrorBoundary';
import TrackedRoute from './TrackedRoute';
import { useFeatureFlags } from '../../utils/useFeatureFlags';

const PrivateRoute = ({
  component: Component,
  render = null,
  tracked,
  ...props
}) => {
  const { user } = useAuth();
  const { loading: isFeatureFlagsLoading } = useFeatureFlags();
  const RouteComponent = tracked ? TrackedRoute : Route;

  return (
    <RouteComponent
      {...props}
      render={(routeProps) => {
        if (
          !user.session.isAuthenticated ||
          Date.now() > user.session.sessionExpiry
        ) {
          if (
            user.session.status === 'pending' ||
            user.isRequestPending === true
          ) {
            return <div />;
          }
          return <Redirect to="/" />;
        }
        if (isFeatureFlagsLoading) {
          return <div />;
        }
        if (typeof render === 'function') {
          return (
            <ErrorBoundary {...routeProps} user={user}>
              {render(routeProps)}
            </ErrorBoundary>
          );
        }

        return (
          <ErrorBoundary {...routeProps} user={user}>
            <Component {...routeProps} />
          </ErrorBoundary>
        );
      }}
    />
  );
};

export default PrivateRoute;
